module.exports = __webpack_public_path__ + "img/personal_resources_transcode_success.181dec7c.svg";